import { api } from './api'
import { AppointmentTypeConfig, AppointmentTypeFormData } from '../types/appointmentType'

export const appointmentTypesService = {
  /**
   * Get all appointment types
   */
  getAll: async (): Promise<AppointmentTypeConfig[]> => {
    const response = await api.get<AppointmentTypeConfig[]>('/settings/appointment-types')
    return response.data
  },

  /**
   * Get a single appointment type by ID
   */
  getById: async (id: string): Promise<AppointmentTypeConfig> => {
    const response = await api.get<AppointmentTypeConfig>(`/settings/appointment-types/${id}`)
    return response.data
  },

  /**
   * Create a new appointment type
   */
  create: async (data: AppointmentTypeFormData): Promise<AppointmentTypeConfig> => {
    const response = await api.post<AppointmentTypeConfig>('/settings/appointment-types', data)
    return response.data
  },

  /**
   * Update an existing appointment type
   */
  update: async (id: string, data: Partial<AppointmentTypeFormData>): Promise<AppointmentTypeConfig> => {
    const response = await api.put<AppointmentTypeConfig>(`/settings/appointment-types/${id}`, data)
    return response.data
  },

  /**
   * Delete an appointment type (only if not default)
   */
  delete: async (id: string): Promise<void> => {
    await api.delete(`/settings/appointment-types/${id}`)
  },

  /**
   * Toggle active status of an appointment type
   */
  toggleActive: async (id: string, isActive: boolean): Promise<AppointmentTypeConfig> => {
    const response = await api.put<AppointmentTypeConfig>(`/settings/appointment-types/${id}/toggle-active`, { isActive })
    return response.data
  },
}
